
		import async from 'preact-cli/async-component';

		function load(cb) {
			require.ensure([], function(require) {
				cb(require("!!../../../node_modules/babel-loader/lib/index.js??ref--0!./index.js"));
			}, "route-reset");
		}

		export default async(load);
	


//////////////////
// WEBPACK FOOTER
// ./routes/reset/index.js
// module id = kiFc
// module chunks = 11